import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle, FiX, FiArrowRight } = FiIcons;

function ChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <aside className="chat-widget" aria-label="Cambia chat assistant">
      {open && (
        <div className="chat-panel">
          <div className="chat-head">
            <div><strong>Cambia Assistant</strong><span>Typically replies quickly</span></div>
            <button onClick={() => setOpen(false)} aria-label="Close chat"><SafeIcon icon={FiX} /></button>
          </div>
          <div className="chat-body">
            <p>Hi — what are you evaluating?</p>
            <a href="#/contact">UCaaS or business phones <SafeIcon icon={FiArrowRight} /></a>
            <a href="#/contact">Contact center <SafeIcon icon={FiArrowRight} /></a>
            <a href="#/contact">Wireless spend <SafeIcon icon={FiArrowRight} /></a>
          </div>
          {/* Drop the Orimon.ai embed script/container here when credentials are available. */}
        </div>
      )}
      <button className="chat-trigger" onClick={() => setOpen(!open)} aria-label="Open chat">
        <SafeIcon icon={open ? FiX : FiMessageCircle} />
      </button>
    </aside>
  );
}

export default ChatWidget;